import type * as Types from "./types";

export const extractContentId = (contentId: Types.ContentId): string => {
  return contentId.split("/Content/")[1];
};
